export const SSO_ERROR_MESSAGE = {
  deactivatedUserAccount: "Invalid SAML response received: User is disabled.",
  preSignupError:
    "Invalid SAML response received: PreSignUp failed with error User with email {{email}} does not exist and cannot be linked to external provider user.",
};
